import api from "@/api/api";
import moment from "moment";
import { logout } from "@/helpers/logout";

function getContactPersonInContact(profile) {
  return profile.contact.contactPersons.map((x) => x.id);
}

export default {
  namespaced: true,

  state: {
    showConfirmMessage: false,
    snackbar: null,
    standaloneMode: false,
    profile: null,
    contactPersonContactIds: [],
    isMainContactPerson: false,
    isTrysilhus: null,
    isLoading: false,
    loadingText: "",
    profileImageUpdate: "",
    checkedIn: {},
    headerName: "",
    isKiosk: false,
    isStartDialogFinished: false,
    noHMScard: false,
  },
  getters: {
    showConfirmMessage: (state) => {
      return state.showConfirmMessage;
    },
    showSnackbar: (state) => {
      return state.snackbar;
    },
    standaloneMode: (state) => {
      return state.standaloneMode;
    },
    profile: (state) => {
      return state.profile;
    },
    contactPersonContactIds: (state) => {
      return state.contactPersonContactIds;
    },
    isMainContactPerson: (state) => {
      return state.isMainContactPerson;
    },
    isTrysilhus: (state) => {
      return state.isTrysilhus;
    },
    isLoading: (state) => {
      return state.isLoading;
    },
    loadingText: (state) => {
      return state.loadingText;
    },
    profileImageUpdate: (state) => {
      return state.profileImageUpdate;
    },
    checkedIn: (state) => {
      return state.checkedIn;
    },
    headerName: (state) => {
      return state.headerName;
    },
    isKiosk: (state) => {
      return state.isKiosk;
    },
    isStartDialogFinished: (state) => {
      return state.isStartDialogFinished;
    },
    noHMScard: (state) => {
      return state.noHMScard;
    },
  },
  mutations: {
    showConfirmMessage(state, value: boolean) {
      state.showConfirmMessage = value;
    },
    showSnackbar(state, snackbar) {
      const newSnackBar = snackbar;
      newSnackBar.show = true;
      state.snackbar = newSnackBar;
    },
    hideSnackbar(state, snackbar) {
      const newSnackBar = snackbar;
      newSnackBar.show = false;
      state.snackbar = newSnackBar;
    },
    standaloneMode(state, value) {
      state.standaloneMode = value;
    },
    profile(state, value) {
      state.profile = value;
      state.isMainContactPerson = value.isMainContactPerson || value.isBTAdmin;
      state.isTrysilhus = value.isTrysilhus;
      state.noHMScard = !value.hmsCardNumber || !value.hmsCardIssuedDate;
    },
    contactPersonContactIds(state, value) {
      state.contactPersonContactIds = value;
    },
    isLoading(state, value) {
      state.isLoading = value;
    },
    loadingText(state, value) {
      state.loadingText = value;
    },
    profileImageUpdate(state, value) {
      state.profileImageUpdate = value;
    },
    checkedIn(state, value) {
      state.checkedIn = value;
    },
    headerName(state, value) {
      state.headerName = value;
    },
    isKiosk(state, value) {
      state.isKiosk = value;
    },
    isStartDialogFinished(state, value) {
      state.isStartDialogFinished = value;
    },
  },
  actions: {
    SetShowConfirmMessage(context, value) {
      context.commit("showConfirmMessage", value);
    },
    showSnackbar(context, snackbar) {
      context.commit("showSnackbar", snackbar);
    },
    hideSnackbar(context, snackbar) {
      context.commit("hideSnackbar", snackbar);
    },
    setStandaloneStatus(context) {
      const value = window.matchMedia("(display-mode: standalone)").matches;
      context.commit("standaloneMode", value);
    },
    async setProfile(context) {
      let data = null;
      await api
        .getContactPerson()
        .then((Response) => {
          data = Response;
          context.commit("profile", data);
          context.commit(
            "contactPersonContactIds",
            getContactPersonInContact(data)
          );
        })
        .catch(() => {
          setTimeout(() => {
            logout();
          }, 2000);
        });
    },
    async updateProfile(context, contactPerson) {
      await context.commit("profile", contactPerson);
      await context.commit(
        "contactPersonContactIds",
        getContactPersonInContact(contactPerson)
      );
    },
    isLoading(context, value) {
      context.commit("isLoading", value);
      if (!value) {
        context.commit("loadingText", "");
      }
    },
    setLoadingText(context, value) {
      context.commit("loadingText", value);
    },
    setProfileImageUpdate({ commit }) {
      const date = moment().format();
      commit("profileImageUpdate", date);
    },
    setCheckedIn(context, value) {
      context.commit("checkedIn", value);
    },
    setHeaderName(context, value) {
      if (value) {
        document.title = value;
      }

      context.commit("headerName", value);
    },
    setIsKiosk(context, value) {
      context.commit("isKiosk", value);
    },
    setIsStartDialogFinished(context, value) {
      context.commit("isStartDialogFinished", value);
    },
  },
};
